import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Collection of field validators for forms
 */
export class FieldValidators {
  /**
   * Validates that a string is a valid HTTP URL
   */
  static httpUrlValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const urlPattern = /^(http|https):\/\/[a-zA-Z0-9.-]+(:\d+)?(\/.*)?$/; // Allows http:// or https://, optional port (:5000) and path
      return value && !urlPattern.test(value)
        ? { invalidUrl: $localize`URL must start with "http://" or "https://" and can include a port number.` }
        : null;
    };
  }

  /**
   * Add more validators here
   * For example: email, required fields, number range, etc.
   */
  static emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return value && !emailPattern.test(value)
        ? { invalidEmail: $localize`Please enter a valid email address` }
        : null;
    };
  }
}
